export enum InComplianceStatus {
    NOT_APPLICABLE = -1,
    IN_COMPLIANCE = 1,
    OUT_OF_COMPLIANCE = 2,
    MISSING = 3
}